<template>
  <div class="vform position-relative" :style="styles.pageColor">
    <shop-header :store-id="currentStoreDoc.ID" />
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9  py-4">
        <div class="container">
          <navigate-user-back />
        </div>
        <div class="container mt-4 pt-4">
          <h1>{{ $t("message.orderTracking") }}</h1>
          <hr />
        </div>
        <div class="container">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <tracking-component
              :order="order"
              :store="currentStoreDoc"
            ></tracking-component>
            <div class="col-sm-12 left-align tracking-hr">
              <hr />
            </div>
          </div>
          <div v-if="pageOrders.length == 0">
            <message :message="getNoOrderAvailable" />
          </div>
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import shared from "../../sharedscripts/user/orderTracking.js";
import Message from "./../shared/Message";
import TrackingComponent from "./partials/trackingComponent";
import { mapGetters } from "vuex";
import shopHeader from "../../components/shop/partials/shopheader";
import navigateUserBack from "./partials/navigateUserBack";
export default {
  components: {
    Pagination,
    Message,
    TrackingComponent,
    shopHeader,
    navigateUserBack,
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev",
        },
      },
      orders: [],
      pageOrders: [],
      loading: false,
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "currentStoreDoc", "styles"]),
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    },
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
